export default __webpack_public_path__ + "static/media/arrow.c599d4e2.svg";